import React from 'react';
import PropTypes from 'prop-types';

const withValidateOnSelectHOCGenerator = (Component) => {
  function WithValidateOnSelectHOC(props) {
    const { inputValue, resetInputValue, multiInputValidateOnSelect, multiInputOnSelect, setValidationMessage } = props;

    const validateOnSelect = () => {
      if (multiInputValidateOnSelect) {
        const { isValid, validationMessage } = multiInputValidateOnSelect(inputValue);

        if (isValid) {
          multiInputOnSelect(inputValue);
          resetInputValue();
        } else {
          setValidationMessage(validationMessage);
        }
      } else {
        multiInputOnSelect(inputValue);
        resetInputValue();
      }
    };

    return <Component {...props} validateOnSelect={validateOnSelect} />;
  }

  WithValidateOnSelectHOC.propTypes = {
    inputValue: PropTypes.string,
    resetInputValue: PropTypes.func,
    multiInputValidateOnSelect: PropTypes.func,
    multiInputOnSelect: PropTypes.func,
    setValidationMessage: PropTypes.func,
  };

  return WithValidateOnSelectHOC;
};

const withValidateOnSelect = () => (Component) => withValidateOnSelectHOCGenerator(Component);

export default withValidateOnSelect;
